<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="6" cy="5" r="2" />
    <circle cx="18" cy="7" r="2" />
    <circle cx="18" cy="17" r="2" />
    <path d="M6 7v5a5 5 0 0 0 5 5h5" />
    <path d="M8 9h3a5 5 0 0 0 5-2" />
  </svg>
</template>

<script setup lang="ts">
/** Branch icon used to fork a conversation at a message. */
</script>
